import { CancelButton, SaveButton } from '@core/components/Buttons';
import { SimpleDialog, SimpleDialogContent } from '@core/components/Dialog';
import { useReduxLoading } from '@core/hooks';
import cancelarAlert from 'app/services/alerts/cancelarAlert';
import { FormikProvider, useFormik } from 'formik';
import moment from 'moment';
import React, { useContext, useEffect } from 'react';
import { FaCreditCard } from 'react-icons/fa';
import { ContaContext } from '../../../ContaContext';
import HistoricoConta from '../../HistoricoConta';
import { modaisConta } from '../modais';
import { useContaBancariaValidation } from '../validation/contaValidation';
import EditarContaBancariaForm from './EditarContaBancariaForm';

const EditarContaBancariaModal = ({ onSubmit }) => {
  const [modal, setModal] = useContext(ContaContext).modal;
  const [conta] = useContext(ContaContext).contaAtual;
  const [historico] = useContext(ContaContext).historico;
  const [search] = useContext(ContaContext).search;
  const [page] = useContext(ContaContext).page;
  const [size] = useContext(ContaContext).size;
  const [loading, setLoading] = useContext(ContaContext).loading;

  const contaBancariaSchema = useContaBancariaValidation();

  useReduxLoading(loading);

  const saldoInicial = conta?.contaBancaria?.saldoInicial;
  const initialValues = {
    descricao: conta.descricao || '',
    contaBancaria: {
      bancoId: conta?.contaBancaria?.bancoId || '',
      bancoCodigo: conta?.contaBancaria?.banco?.codigo || '',
      tipoConta: conta?.contaBancaria?.tipoConta ? conta?.contaBancaria?.tipoConta : 'CORRENTE',
      agencia: conta?.contaBancaria?.agencia || '',
      agenciaDigito: conta?.contaBancaria?.agenciaDigito || '',
      numeroConta: conta?.contaBancaria?.numeroConta || '',
      contaDigito: conta?.contaBancaria?.contaDigito || '',
      saldoInicial: saldoInicial !== null || saldoInicial !== undefined ? saldoInicial : 0,
      dataSaldo: conta?.contaBancaria?.dataSaldo ? moment(conta?.contaBancaria?.dataSaldo) : null,
      dataEncerramento: conta?.contaBancaria?.dataEncerramento ? moment(conta?.contaBancaria?.dataEncerramento) : null,
      encerrarConta: !!conta?.contaBancaria?.dataEncerramento,
      principal: conta?.contaBancaria?.principal || false,
    },
  };

  const handleSubmit = async (data) => {
    setLoading(true);
    data.id = conta?.id;
    data.contaBancaria.id = conta?.contaBancaria?.id;

    data.contaBancaria = {
      ...data?.contaBancaria,
    };

    const submit = async (_data) => {
      setLoading(true);
      const res = await onSubmit(_data, { page, size, q: search });

      setLoading(false);
      if (res) {
        setModal('');
      }
    };

    submit(data);
  };

  const formik = useFormik({
    onSubmit: handleSubmit,
    validationSchema: contaBancariaSchema,
    validateOnBlur: true,
    validateOnChange: true,
    initialValues,
  });

  const handleClose = () => {
    const close = () => {
      formik.resetForm(initialValues);
      setModal('');
    };

    if (formik.dirty) {
      cancelarAlert({
        confirmar: close,
      });
    } else {
      close();
    }
  };

  useEffect(() => {
    formik.resetForm(initialValues);
    // Reset controlado pelo gatilho acima; incluir o formulário/valores reiniciaria o
    // preenchimento enquanto o usuário edita.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conta]);

  const Buttons = (
    <>
      <CancelButton title="cancelar" type="button" onClick={handleClose}>
        Cancelar
      </CancelButton>
      <SaveButton color="buttonSave" type="button" onClick={formik.handleSubmit}>
        Salvar
      </SaveButton>
    </>
  );

  return (
    <FormikProvider value={formik}>
      <SimpleDialog fullScreen open={modal === modaisConta.editarContaBancaria} onClose={handleClose}>
        <SimpleDialogContent
          fullScreen
          header={{ title: 'Cadastro de conta bancária', icon: <FaCreditCard />, toolbar: Buttons }}
          content={
            <>
              <div style={{ padding: 16 }}>
                <EditarContaBancariaForm />
              </div>
              {conta?.id && historico.length > 0 && <HistoricoConta historico={historico} />}
            </>
          }
          contentStyle={{
            padding: 0,
          }}
        />
      </SimpleDialog>
    </FormikProvider>
  );
};

export default EditarContaBancariaModal;
